import { render, staticRenderFns } from "./FeedbackPopup.vue?vue&type=template&id=b6c4b64c&"
import script from "./FeedbackPopup.vue?vue&type=script&lang=js&"
export * from "./FeedbackPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports